export default {
  row: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 10,
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'rgba(0, 0, 0, 0.85)',
    fontSize: 16,
  },
  breadcrumbStyle: {
    margin: '0 0 16px 0',
    padding: '16px 0 16px 0',
    fontSize: '15px',
    background: '#f0f2f5 !important',
  },
};
